import { useMemo } from "react"

import { twMerge } from "tailwind-merge"

function computeClassNamesFor(initials: string) {
  const colors = [
    { text: "text-lilac-500", background: "bg-lilac-100" },
    { text: "text-sky-500", background: "bg-sky-100" },
    { text: "text-navy-800", background: "bg-navy-100" },
    { text: "text-magenta-500", background: "bg-magenta-100" },
  ]

  const index =
    initials?.split("")?.reduce((accumulator: number, letter: string) => accumulator + letter.charCodeAt(0), 0) %
    colors.length

  const { text, background } = colors[index] ?? {}
  return [text, background]
}

export type AvatarProps = {
  className?: string
  initials: string
}

export function Avatar({ className, initials }: AvatarProps) {
  const properInitials = initials.toUpperCase()
  const [backgroundColor, textColor] = useMemo(() => computeClassNamesFor(properInitials), [properInitials])

  return (
    <div className={twMerge("flex items-center gap-1 rounded-full", backgroundColor, textColor, className)}>
      <div className="flex h-12 w-12 items-center justify-center rounded-full">
        <span className="overflow-hidden text-center text-current">{properInitials}</span>
      </div>
    </div>
  )
}
